import React, { createContext, useContext } from "react";
import { useInitApi } from "./configuration";

import type {API} from './configuration' 
const apiContext = createContext<API | null>(null);

export const useApi = (): API => {
  const api = useContext(apiContext);
  if (!api) {
    throw new Error(
      "Cannot use API context outside of the API provider's descendants"
    );
  }

  return api;
};

export const ApiProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const api = useInitApi();
  return <apiContext.Provider value={api}>{children}</apiContext.Provider>;
};

